import { call, put, takeEvery, takeLatest } from "redux-saga/effects"

// MadridNotifier Redux States
import { 
  GET_DOMAIN_LIST,
  GET_DOMAIN_ACTION_HISTORY,
  SAVE_DOMAIN_INFO,
  GET_BLACK_LIST,
  ADD_BLACK_DOMAIN,
  DOWN_EXCEL_BLACK_LIST,
  GET_ENTITY_DETAIL,
  SAVE_ENTITY_EMAILS,
  DELETE_ENTITY_EMAILS,
  GET_PCT_STAGING_EMAILS,
  SAVE_PCT_STAGING_EMAILS,
  FETCH_PCT_ENTITY_DETAIL,
  DELETE_AUTO_SCRAPE_ENTITY_EMAILS,
  GET_UNSUBSCRIBE_LIST,
  ADD_UNSUBSCRIBE_DOMAIN,
  DELETE_UNSUBSCRIBE_DOMAIN,
} from "./actionTypes"
import { 
  getDomainListSuccess,
  getDomainActionHistorySuccess,
  saveDomainInfoSuccess,
  getBlackListSuccess,
  addBlackListSuccess,
  downExcelBlackListSuccess,
  getEntityDetailSuccess,
  saveEntityEmailsSuccess,
  deleteEntityEmailsSuccess,
  getPctStagingEmailsSuccess,
  savePctStagingEmailsSuccess,
  fetchPctEntityDetailSuccess,
  deleteAutoScrapedEmailsSuccess,
  getUnsubscribeList as getUnsubscribeListAction,
  getUnsubscribeListSuccess,
  addUnsubscribeListSuccess,
  getEntityDetail as getEntityDetailAction,
  deleteUnsubscribeListSuccess
} from "./actions"

//Include Both Helper File with needed methods
import {
  getDomainList,
  getDomainActionHistory,
  saveDomainInfo,
  getBlackList,
  addBlackList,
  downExcelBlackList,
  getEntityDetail,
  saveEntityEmails,
  deleteEntityEmails,
  getPctStagingEmails,
  savePctEntityEmails,
  deleteAutoScrapedEntityEmails,
  getUnsubscribeList,
  addUnsubscribeList,
  deleteUnsubscribeList,
} from "../../helpers/backend_helper"

function* onGetDomainList({ payload : data }) {
  try {
    const response = yield call(getDomainList, data);
    yield put(getDomainListSuccess(response));
    
  } catch (error) {
    console.log('onGetDomainList error >> ' + error);
  }
}

function* onGetDomainActionHistory({ payload : data }) {
  try {
    const response = yield call(getDomainActionHistory, data);
    yield put(getDomainActionHistorySuccess(response));
    
  } catch (error) {
    console.log('onGetDomainActionList error >> ' + error);
  }
}

function* onSaveDomainInfo({ payload : data }) {
  try {
    const response = yield call(saveDomainInfo, data);
    yield put(saveDomainInfoSuccess(response));
    
  } catch (error) {
    console.log('onSaveDomainInfo error >> ' + error);
  }
}

function* onGetBlackList({ payload : data }) {
  try {
    const response = yield call(getBlackList, data);
    yield put(getBlackListSuccess(response));
    
  } catch (error) {
    console.log('onGetBlackList error >> ' + error);
  }
}

function* onAddBlackList({ payload : data }) {
  try {
    const response = yield call(addBlackList, data);
    yield put(addBlackListSuccess(response));
    
  } catch (error) {
    console.log('onAddBlackList error >> ' + error);
  }
}

function* onGetUnsubscribeList({ payload : data }) {
  try {
    const response = yield call(getUnsubscribeList, data);
    yield put(getUnsubscribeListSuccess(response));
    
  } catch (error) {
    console.log('onGetUnsubscribeList error >> ' + error);
  }
}

function* onAddUnsubscribeList({ payload: data }) {
  try {
    const response = yield call(addUnsubscribeList, data);
    yield put(addUnsubscribeListSuccess(response));
    // if (response && response.success) {
    //   yield put(getUnsubscribeListAction({
    //     unsubscribeValue: "",
    //     curPage: data.curPage,
    //     perPage: data.perPage,
    //   }));
    // }
  } catch (error) {
    console.log('onAddUnsubscribeList error >>', error);
  }
}

function* onDeleteUnsubscribeList({ payload: data }) {
  try {
    const response = yield call(deleteUnsubscribeList, data);
    yield put(deleteUnsubscribeListSuccess(response));
    if (response && response.success) {
      yield put(getUnsubscribeListAction({
        unsubscribeValue: "",
        curPage: data.curPage,
        perPage: data.perPage,
      }));
    }
  } catch (error) {
    console.log('onAddUnsubscribeList error >>', error);
  }
}

function* onDownExcelBlackList({ payload : data}) {
  try {
    yield call(downExcelBlackList, data);
    yield put(downExcelBlackListSuccess());

  } catch (error) {
    console.log('onDownExcelBlackList error >> ' + error);
  }
}

function* onGetEntityDetail({ payload : data }) {
  try {
    const response = yield call(getEntityDetail, data);
    yield put(getEntityDetailSuccess(response));
    
  } catch (error) {
    console.log('getEntityDetail error >> ' + error);
  }
}

function* onSaveEntityEmails({ payload: data }) {
  try {
    const response = yield call(saveEntityEmails, data.param);
    yield put(saveEntityEmailsSuccess(response));
    yield put(getEntityDetailAction(data.filter))
    
  } catch (error) {
    console.log('onSaveEntityEmails error >> ' + error);
  }
}

function* onDeleteEntityEmails({ payload: data }) {
  try {
    const response = yield call(deleteEntityEmails, data.param);
    yield put(deleteEntityEmailsSuccess(response));
    yield put(getEntityDetailAction(data.filter))
  } catch (error) {
    console.log('onDeleteEntityEmails error >> ' + error);
  }
}

function* onDeleteAutoScrapedEntityEmails({ payload: data }) {
  try {
    const response = yield call(deleteAutoScrapedEntityEmails, data);
    yield put(deleteAutoScrapedEmailsSuccess(response));
    
  } catch (error) {
    console.log('onDeleteAutoScrapedEntityEmails error >> ' + error);
  }
}

function* onGetPctStagingEmails({ payload: data }) {
  try {
    const response = yield call(getPctStagingEmails, data);
    yield put(getPctStagingEmailsSuccess(response));
    
  } catch (error) {
    console.log('onGetPctStagingEmails error >> ' + error);
  }
}

function* onSavePctStagingEmails({ payload: data }) {
  try {
    const response = yield call(savePctEntityEmails, data);
    yield put(savePctStagingEmailsSuccess(response));
    
  } catch (error) {
    console.log('onSavePctStagingEmails error >> ' + error);
  }
}

function* onFetchPctEntityDetail({ payload: data }) {
  try {
    // data: { targetGroupNo, rowIndex }
    const response = yield call(getEntityDetail, { targetGroupNo: data.targetGroupNo });
    const { entityDetail } = response || {};

    yield put(fetchPctEntityDetailSuccess({
      rowIndex: data.rowIndex,
      domain: entityDetail && entityDetail.domain ? entityDetail.domain : "",
      domainVerified: entityDetail && entityDetail.domainCorrectYn ? entityDetail.domainCorrectYn : "",
    }));
    
  } catch (error) {
    console.log('onFetchPctEntityDetail error >> ' + error);
  }
}

function* AdmDomainManagementSaga() {
  yield takeLatest(GET_DOMAIN_LIST, onGetDomainList);
  yield takeLatest(GET_DOMAIN_ACTION_HISTORY, onGetDomainActionHistory);
  yield takeLatest(SAVE_DOMAIN_INFO, onSaveDomainInfo);
  
  yield takeLatest(GET_BLACK_LIST, onGetBlackList);
  yield takeLatest(ADD_BLACK_DOMAIN, onAddBlackList);
  yield takeLatest(DOWN_EXCEL_BLACK_LIST, onDownExcelBlackList);

  yield takeLatest(GET_UNSUBSCRIBE_LIST, onGetUnsubscribeList);
  yield takeLatest(ADD_UNSUBSCRIBE_DOMAIN, onAddUnsubscribeList);
  yield takeLatest(DELETE_UNSUBSCRIBE_DOMAIN, onDeleteUnsubscribeList);

  yield takeLatest(GET_ENTITY_DETAIL, onGetEntityDetail);
  yield takeLatest(SAVE_ENTITY_EMAILS, onSaveEntityEmails);
  yield takeLatest(DELETE_ENTITY_EMAILS, onDeleteEntityEmails);
  yield takeLatest(DELETE_AUTO_SCRAPE_ENTITY_EMAILS, onDeleteAutoScrapedEntityEmails)

  yield takeLatest(GET_PCT_STAGING_EMAILS, onGetPctStagingEmails);
  yield takeLatest(SAVE_PCT_STAGING_EMAILS, onSavePctStagingEmails);
  yield takeLatest(FETCH_PCT_ENTITY_DETAIL, onFetchPctEntityDetail);
}

export default AdmDomainManagementSaga

